/**
 * VOIP Service for handling calls through backend proxy
 */

import { apiInterfaceForJson } from "../common/apiManager";

// Backend API configuration
const API_BASE_URL = process.env.REACT_APP_API_HOST_NAME || "http://localhost:8086";

/**
 * Initiate a call through Voiso
 * @param {Object} params - Call parameters
 * @param {string} params.phoneNumber - The phone number to call
 * @param {string} params.agentId - The agent making the call
 * @param {string} params.leadId - The lead ID for tracking
 * @returns {Promise} - Call initiation response
 */
export const initiateVoisoCall = async ({ phoneNumber, agentId, leadId }) => {
    try {
        // const response = await fetch(`${API_BASE_URL}/voip/v1/calls/initiate`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify({
        //         provider: "voiso",
        //         phoneNumber,
        //         agentId,
        //         leadId
        //     })
        // });

        // if (!response.ok) {
        //     const errorData = await response.json();
        //     throw new Error(errorData.error || `API error: ${response.status}`);
        // }

        // return await response.json();
        const query = {
            provider: "voiso",
            phoneNumber,
            agentId,
            leadId
        };
        return apiInterfaceForJson("/voip/v1/calls/initiate", "POST", query);
    } catch (error) {
        console.error("Voiso call initiation error:", error);
        return {
            success: false,
            error: error.message,
            provider: "voiso"
        };
    }
};

/**
 * Initiate a call through CommPeak
 * @param {Object} params - Call parameters
 * @param {string} params.phoneNumber - The phone number to call
 * @param {string} params.agentId - The agent making the call
 * @param {string} params.leadId - The lead ID for tracking
 * @param {string} params.extension - Optional extension (for test calls)
 * @returns {Promise} - Call initiation response
 */
export const initiateCommpeakCall = async ({ phoneNumber, agentId, leadId, extension }) => {
    try {
        const query = {
            provider: "commpeak",
            phoneNumber,
            leadId
        };
        // If extension is provided, use it (for test calls), otherwise use agentId
        if (extension) {
            query.extension = extension;
        } else if (agentId) {
            query.agentId = agentId;
        }
        return apiInterfaceForJson("/voip/v1/calls/initiate", "POST", query);
    } catch (error) {
        console.error("CommPeak call initiation error:", error);
        return {
            success: false,
            error: error.message,
            provider: "commpeak"
        };
    }
};

/**
 * Initiate a call through Coperato
 * @param {Object} params - Call parameters
 * @param {string} params.phoneNumber - The phone number to call
 * @param {string} params.agentId - The agent making the call
 * @param {string} params.leadId - The lead ID for tracking
 * @returns {Promise} - Call initiation response
 */
export const initiateCoperatoCall = async ({ phoneNumber, agentId, leadId }) => {
    try {
        // const response = await fetch(`${API_BASE_URL}/voip/v1/calls/initiate`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify({
        //         provider: "coperato",
        //         phoneNumber,
        //         agentId,
        //         leadId
        //     })
        // });

        // if (!response.ok) {
        //     const errorData = await response.json();
        //     throw new Error(errorData.error || `API error: ${response.status}`);
        // }
        // return await response.json();
        const query = {
            provider: "coperato",
            phoneNumber,
            agentId,
            leadId
        };
        return apiInterfaceForJson("/voip/v1/calls/initiate", "POST", query);
    } catch (error) {
        console.error("Coperato call initiation error:", error);
        return {
            success: false,
            error: error.message,
            provider: "coperato"
        };
    }
};

/**
 * Get call status from Voiso
 * @param {string} callId - The call ID to check
 * @returns {Promise} - Call status response
 */
export const getVoisoCallStatus = async (callId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/voip/v1/calls/voiso/${callId}/status`);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `API error: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Voiso call status error:", error);
        throw error;
    }
};

/**
 * Get call status from CommPeak
 * @param {string} callId - The call ID to check
 * @returns {Promise} - Call status response
 */
export const getCommpeakCallStatus = async (callId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/voip/v1/calls/commpeak/${callId}/status`);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `API error: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("CommPeak call status error:", error);
        throw error;
    }
};

/**
 * Initiate a call through SquareTalk
 * @param {Object} params - Call parameters
 * @param {string} params.phoneNumber - The phone number to call
 * @param {string} params.agentId - The agent making the call
 * @param {string} params.leadId - The lead ID for tracking
 * @returns {Promise} - Call initiation response
 */
export const initiateSquareTalkCall = async ({ phoneNumber, agentId, leadId, extension }) => {
    try {
        const query = {
            provider: "squaretalk",
            phoneNumber,
            leadId
        };
        // If extension is provided, use it (for test calls), otherwise use agentId
        if (extension) {
            query.extension = extension;
        } else if (agentId) {
            query.agentId = agentId;
        }
        return apiInterfaceForJson("/voip/v1/calls/initiate", "POST", query);
    } catch (error) {
        console.error("SquareTalk call initiation error:", error);
        return {
            success: false,
            error: error.message,
            provider: "squaretalk"
        };
    }
};

/**
 * Get call status from Coperato
 * @param {string} callId - The call ID to check
 * @returns {Promise} - Call status response
 */
export const getCoperatoCallStatus = async (callId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/voip/v1/calls/coperato/${callId}/status`);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `API error: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Coperato call status error:", error);
        throw error;
    }
};

/**
 * Get call status from SquareTalk
 * @param {string} extension - The extension to check status for (SquareTalk uses extension, not callId)
 * @returns {Promise} - Call status response
 */
export const getSquareTalkCallStatus = async (extension) => {
    try {
        // SquareTalk uses extension for status check, not callId
        const response = await fetch(`${API_BASE_URL}/voip/v1/calls/squaretalk/${extension}/status?extension=${encodeURIComponent(extension)}`);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `API error: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("SquareTalk call status error:", error);
        throw error;
    }
};

/**
 * End a call
 * @param {string} callId - The call ID to end (for SquareTalk, this is the extension)
 * @param {string} provider - The provider ('voiso', 'commpeak', 'coperato', or 'squaretalk')
 * @param {string} extension - Optional extension (required for SquareTalk)
 * @returns {Promise} - Call termination response
 */
export const endCall = async (callId, provider, extension = null) => {
    try {
        let url = `/voip/v1/calls/${provider}/${callId}/end`;
        
        // For SquareTalk, add extension as query parameter
        if (provider === "squaretalk" && extension) {
            url += `?extension=${encodeURIComponent(extension)}`;
        } else if (provider === "squaretalk" && !extension) {
            // If no extension provided but provider is SquareTalk, use callId as extension
            url += `?extension=${encodeURIComponent(callId)}`;
        }
        
        // Use apiInterfaceForJson to include authentication token
        return apiInterfaceForJson(url, "POST", {});
    } catch (error) {
        console.error(`${provider} end call error:`, error);
        throw error;
    }
};

/**
 * Log call activity
 * @param {Object} callData - Call data to log
 */
export const logCallActivity = async (callData) => {
    try {
        return apiInterfaceForJson("/voip/v1/calls/log", "POST", callData);
    } catch (error) {
        console.error("Call logging error:", error);
        throw error;
    }
};

/**
 * Initiate a call through GlobalCall
 * @param {Object} params - Call parameters
 * @param {string} params.phoneNumber - The phone number to call
 * @param {string} params.agentId - The agent ID for logging
 * @param {string} params.leadId - The lead ID for tracking
 * @param {string} params.agentSipAccount - The agent's SIP account
 * @param {string} params.clientName - The client's name (optional)
 * @returns {Promise} - Call initiation response
 */
export const initiateGlobalCallCall = async ({
    phoneNumber,
    agentId,
    leadId,
    agentSipAccount,
    clientName = ""
}) => {
    try {
        const query = {
            provider: "globalcall",
            phoneNumber,
            agentId,
            leadId,
            agentSipAccount,
            clientName
        };
        return apiInterfaceForJson("/voip/v1/calls/initiate", "POST", query);
    } catch (error) {
        console.error("GlobalCall call initiation error:", error);
        return {
            success: false,
            error: error.message,
            provider: "globalcall"
        };
    }
};

/**
 * Initiate a call through Bubble VoIP
 * @param {Object} params - Call parameters
 * @param {string} params.phoneNumber - The phone number to call
 * @param {string} params.agentId - The agent making the call
 * @param {string} params.leadId - The lead ID for tracking
 * @param {string} params.extension - Optional extension (for test calls)
 * @returns {Promise} - Call initiation response
 */
export const initiateBubbleVoipCall = async ({ phoneNumber, agentId, leadId, extension }) => {
    try {
        const query = {
            provider: "bubblevoip",
            phoneNumber,
            leadId
        };
        // If extension is provided, use it (for test calls), otherwise use agentId
        if (extension) {
            query.extension = extension;
        } else if (agentId) {
            query.agentId = agentId;
        }
        return apiInterfaceForJson("/voip/v1/calls/initiate", "POST", query);
    } catch (error) {
        console.error("Bubble VoIP call initiation error:", error);
        return {
            success: false,
            error: error.message,
            provider: "bubblevoip"
        };
    }
};

/**
 * Handle call completion - Updates lead and logs call
 * @param {Object} callData - Call completion data
 * @param {string} callData.provider - VoIP provider
 * @param {string} callData.callId - Call ID
 * @param {string} callData.leadId - Lead ID
 * @param {string} callData.agentId - Agent ID
 * @param {number} callData.duration - Call duration in seconds
 * @param {string} callData.status - Call status (completed, failed, etc.)
 * @param {string} callData.startTime - Call start time
 * @returns {Promise} - Completion response
 */
export const handleCallCompletion = async (callData) => {
    try {
        return apiInterfaceForJson("/voip/v1/calls/complete", "POST", callData);
    } catch (error) {
        console.error("Call completion error:", error);
        throw error;
    }
};
